import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, InputModule, RadioCheckboxModule, FormFieldsModule, RadioCheckboxListModule, ProgressModule, LibPopoverModule, SelectModule, NgxSmartModalModule, DataTableModule } from '@bssh/comp-lib';
import { ReactiveFormsModule } from '@angular/forms';
import { ComboBoxModule } from '@app/cloud-run-prep/directives/combobox/combobox.module';
import { AnalysisDefinitionModalComponent } from './analysis-definition-modal.component';

@NgModule({
  declarations: [AnalysisDefinitionModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DataTableModule,
    InputModule,
    RadioCheckboxModule, 
    ButtonModule,
    FormFieldsModule, 
    RadioCheckboxListModule, 
    ProgressModule, 
    LibPopoverModule,
    ReactiveFormsModule,
    ComboBoxModule,
    SelectModule,
    NgxSmartModalModule
  ],
  exports: [AnalysisDefinitionModalComponent]
})
export class AnalysisDefinitionModalModule { }
